// ModalContext.js
import { createContext } from 'react';

const PhoneNumberModalContext = createContext(true);

export default PhoneNumberModalContext;